import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import MainNav from "@/components/MainNav";

export default function HomePage() {
  return (
    <div className="min-h-screen bg-background flex flex-col" data-testid="homepage">
      {/* Use the main navigation */}
      <MainNav />

      {/* Hero */}
      <main className="flex-1 flex items-center justify-center pt-16">
        <motion.div
          initial={{ opacity: 0, scale: 0.9 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.8 }}
          className="text-center px-4"
        >
          {/* Logo with depth effect - subtle size */}
          <div className="relative mb-2 md:mb-4">
            {/* Glow effect behind logo */}
            <div className="absolute inset-0 blur-3xl opacity-10 bg-gradient-to-b from-white/20 to-transparent scale-150" />
            
            {/* Main logo with shadow and subtle animation */}
            <motion.img 
              src="https://customer-assets.emergentagent.com/job_music-connect-23/artifacts/mbsj96z9_UNDERPLAY%20MUSIC%20LOGO%20NEW%202025%20no%20border%20no%20TEXT.png" 
              alt="Underplay" 
              className="h-20 md:h-24 lg:h-28 w-auto mx-auto relative z-10 drop-shadow-2xl"
              style={{
                filter: 'drop-shadow(0 0 30px rgba(255,255,255,0.08)) drop-shadow(0 20px 40px rgba(0,0,0,0.4))'
              }}
              animate={{ 
                y: [0, -5, 0],
              }}
              transition={{ 
                duration: 6,
                repeat: Infinity,
                ease: "easeInOut"
              }}
            />
          </div>
          
          {/* Title - softer, lowercase with subtle outline */}
          <motion.h1 
            className="text-3xl md:text-4xl font-normal tracking-[0.6em] text-zinc-300 mb-24 md:mb-32 pl-[0.3em]"
            style={{ 
              fontFamily: "'Space Grotesk', sans-serif"
            }}
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.3, duration: 0.6 }}
          >
            underplay
          </motion.h1>
          
          {/* Quick Links - grey with white outline on hover */}
          <motion.div 
            className="flex flex-col md:flex-row justify-center gap-3 md:gap-4"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.7, duration: 0.6 }}
          >
            <Link to="/management">
              <motion.div 
                whileHover={{ scale: 1.05, borderColor: 'rgba(255,255,255,0.6)' }}
                whileTap={{ scale: 0.98 }}
                className="px-8 py-3 border border-zinc-700 rounded-full text-sm text-zinc-500 hover:text-zinc-300 hover:border-zinc-400 transition-all backdrop-blur-sm"
              >
                Management
              </motion.div>
            </Link>
            <Link to="/promotion">
              <motion.div 
                whileHover={{ scale: 1.05, borderColor: 'rgba(255,255,255,0.6)' }}
                whileTap={{ scale: 0.98 }}
                className="px-8 py-3 border border-zinc-700 rounded-full text-sm text-zinc-500 hover:text-zinc-300 hover:border-zinc-400 transition-all backdrop-blur-sm"
              >
                Promotion
              </motion.div>
            </Link>
            <Link to="/recordings">
              <motion.div 
                whileHover={{ scale: 1.05, borderColor: 'rgba(255,255,255,0.6)' }}
                whileTap={{ scale: 0.98 }}
                className="px-8 py-3 border border-zinc-700 rounded-full text-sm text-zinc-500 hover:text-zinc-300 hover:border-zinc-400 transition-all backdrop-blur-sm"
              >
                Recordings
              </motion.div>
            </Link>
          </motion.div>

          {/* Social hint */}
          <motion.div
            className="mt-16 flex justify-center gap-6"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 1, duration: 0.6 }}
          >
            <a 
              href="https://www.instagram.com/u_n_d_e_r_p_l_a_y/" 
              target="_blank" 
              rel="noopener noreferrer"
              className="text-zinc-600 hover:text-white transition-colors text-xs tracking-wider"
            >
              INSTAGRAM
            </a>
            <span className="text-zinc-800">|</span>
            <Link 
              to="/contact"
              className="text-zinc-600 hover:text-white transition-colors text-xs tracking-wider"
            >
              CONTACT
            </Link>
          </motion.div>
        </motion.div>
      </main>

      {/* Footer */}
      <footer className="border-t border-zinc-800 py-6">
        <div className="max-w-6xl mx-auto px-4 text-center">
          <p className="text-zinc-600 text-xs">© 2025 Underplay. All rights reserved.</p>
        </div>
      </footer>
    </div>
  );
}
